import store from '@polleverywhere/redux'
import { slice as profileSlice } from '@polleverywhere/redux/slices/profile'

export default async function destroySession () {
  await store.dispatch(profileSlice.logout())
}
